export default "__VITE_ASSET__VfrSqaAM__"